<template>
  <div class="shadow-short mood-inverse aspect-square w-full rounded-lg">
    <div
      class="relative flex size-full flex-col justify-end overflow-hidden rounded-lg"
    >
      <RevIllustration
        :alt="title"
        :height="360"
        image-class-names="absolute inset-0 size-full object-cover"
        :src="image"
        :width="360"
      />
      <div
        class="pointer-events-none absolute inset-x-0 bottom-0 h-[77.78%] backdrop-blur-[6px] [mask-image:linear-gradient(to_bottom,transparent_0%,black_100%)]"
      />
      <div
        class="pointer-events-none absolute inset-x-0 bottom-0 h-[77.78%] bg-gradient-to-b from-transparent to-[#121016]/60"
      />
      <div class="relative flex flex-col gap-16 p-24">
        <div class="flex flex-col gap-4">
          <p class="heading-2 text-static-default-mid">{{ title }}</p>
          <p
            class="body-1-bold line-clamp-2 h-48 text-static-default-mid"
            :title="description"
          >
            {{ description }}
          </p>
        </div>
        <RevButton
          class="w-fit"
          size="small"
          :to="ctaUrl"
          :tracking
          variant="primary"
        >
          {{ ctaLabel }}
        </RevButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  image: string
  title: string
  description: string
  ctaLabel: string
  ctaUrl: string
  tracking?: Record<string, string>
}>()
</script>
